(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-passport-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('passport-hero')) {
    customElements.define('passport-hero', class extends HTMLElement {
      connectedCallback() {
        this.openLabel = this.dataset.openLabel;
        this.closeLabel = this.dataset.closeLabel;
        this.control = this.querySelector('.passport-hero__interaction');
        this.status = this.querySelector('[data-passport-status]');
        this.scene = this.querySelector('.passport-hero__scene');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.entranceTimer = 0;
        this.closeTimer = 0;
        this.scrollOpenFrame = 0;
        this.scrollOpenStart = window.scrollY;
        this.handleScrollOpen = () => this.requestScrollOpen();

        this.control.addEventListener('click', () => this.setOpen(!this.classList.contains('is-open')));
        this.prepareEntrance();
        this.prepareScrollOpen();

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) {
            this.setOpen(false);
            this.control.focus();
          }
        });

        this.scene.addEventListener('pointermove', (event) => this.handlePointerMove(event));
        this.scene.addEventListener('pointerleave', () => this.resetTilt());
      }

      setOpen(isOpen) {
        window.clearTimeout(this.closeTimer);
        this.classList.remove('is-closing');
        if (!isOpen && !this.reducedMotion.matches) this.classList.add('is-closing');
        this.classList.toggle('is-open', isOpen);
        if (isOpen) this.stopScrollOpen();
        if (!isOpen && !this.reducedMotion.matches) {
          this.closeTimer = window.setTimeout(() => this.classList.remove('is-closing'), 1180);
        }
        const label = isOpen ? this.closeLabel : this.openLabel;

        this.control.setAttribute('aria-expanded', String(isOpen));
        this.control.setAttribute('aria-label', label);
        this.status.textContent = isOpen ? 'Passport opened.' : 'Passport closed.';
      }

      prepareEntrance() {
        if (this.reducedMotion.matches) {
          this.classList.remove('is-entrance-pending');
          this.classList.add('is-entrance-complete');
          return;
        }

        const groups = ['heading', 'body'];
        let nextDelay = 170;

        window.requestAnimationFrame(() => {
          groups.forEach((group) => {
            const container = this.querySelector(`[data-passport-reveal="${group}"]`);
            const words = group === 'heading'
              ? Array.from(container?.children || []).map((element) => {
                  element.classList.add('passport-hero__reveal-word');
                  return element;
                })
              : this.wrapRevealWords(container);
            const lines = [];

            words.forEach((word) => {
              const top = Math.round(word.getBoundingClientRect().top);
              const line = lines.find((item) => Math.abs(item.top - top) <= 2);
              if (line) line.words.push(word);
              else lines.push({ top, words: [word] });
            });

            lines.sort((a, b) => a.top - b.top).forEach((line, index) => {
              line.words.forEach((word) => word.style.setProperty('--passport-reveal-delay', `${nextDelay + index * 115}ms`));
            });
            nextDelay += Math.max(lines.length, 1) * 115 + 130;
          });

          this.querySelector('[data-passport-reveal="badge"]')?.style.setProperty('--passport-element-delay', `${nextDelay}ms`);

          window.requestAnimationFrame(() => this.classList.add('is-entrance-ready'));
          this.entranceTimer = window.setTimeout(() => {
            this.classList.remove('is-entrance-pending');
            this.classList.add('is-entrance-complete');
          }, nextDelay + 850);
        });
      }

      prepareScrollOpen() {
        window.addEventListener('scroll', this.handleScrollOpen, { passive: true });
      }

      requestScrollOpen() {
        if (this.scrollOpenFrame || Math.abs(window.scrollY - this.scrollOpenStart) < 16) return;

        this.scrollOpenFrame = window.requestAnimationFrame(() => {
          this.scrollOpenFrame = 0;
          const visual = this.querySelector('[data-passport-visual]');
          const bounds = visual?.getBoundingClientRect();
          if (!bounds || bounds.top > window.innerHeight * 0.78 || bounds.bottom < window.innerHeight * 0.18) return;
          this.setOpen(true);
        });
      }

      stopScrollOpen() {
        window.removeEventListener('scroll', this.handleScrollOpen);
        if (!this.scrollOpenFrame) return;
        window.cancelAnimationFrame(this.scrollOpenFrame);
        this.scrollOpenFrame = 0;
      }

      wrapRevealWords(container) {
        if (!container || !('NodeFilter' in window)) return [];
        const existing = Array.from(container.querySelectorAll('.passport-hero__reveal-word'));
        if (existing.length) return existing;

        const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
          acceptNode: (node) => node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
        });
        const textNodes = [];
        let node;
        while ((node = walker.nextNode())) textNodes.push(node);

        textNodes.forEach((textNode) => {
          const fragment = document.createDocumentFragment();
          textNode.nodeValue.split(/(\s+)/).forEach((token) => {
            if (!token) return;
            if (/\s/.test(token)) {
              fragment.appendChild(document.createTextNode(token));
              return;
            }
            const word = document.createElement('span');
            word.className = 'passport-hero__reveal-word';
            word.textContent = token;
            fragment.appendChild(word);
          });
          textNode.parentNode.replaceChild(fragment, textNode);
        });

        return Array.from(container.querySelectorAll('.passport-hero__reveal-word'));
      }

      handlePointerMove(event) {
        if (event.pointerType === 'touch' || this.reducedMotion.matches) return;
        const bounds = this.scene.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        this.scene.style.setProperty('--passport-rotate-x', `${6 - y * 12}deg`);
        this.scene.style.setProperty('--passport-rotate-y', `${-8 + x * 16}deg`);
      }

      resetTilt() {
        this.scene.style.removeProperty('--passport-rotate-x');
        this.scene.style.removeProperty('--passport-rotate-y');
      }

      disconnectedCallback() {
        window.clearTimeout(this.entranceTimer);
        window.clearTimeout(this.closeTimer);
        this.stopScrollOpen();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-story-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-story-grid')) {
    customElements.define('maison-story-grid', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.cards = Array.from(this.querySelectorAll('.msg__video-card')).map(card => {
          const video = card.querySelector('video');
          const item = { card, video, visible: false, userPaused: false, userStarted: false };
          video.controls = false;
          video.muted = true;
          card.querySelector('.msg__controls').hidden = false;
          const sync = () => {
            const playing = !video.paused;
            card.querySelector('[data-play]').setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
            card.querySelector('[data-play-icon]').toggleAttribute('hidden', playing);
            card.querySelector('[data-pause-icon]').toggleAttribute('hidden', !playing);
            card.querySelector('[data-sound]').setAttribute('aria-label', video.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
            card.querySelector('[data-sound]').setAttribute('aria-pressed', String(!video.muted));
            card.querySelector('[data-muted-icon]').toggleAttribute('hidden', !video.muted);
            card.querySelector('[data-audible-icon]').toggleAttribute('hidden', video.muted);
          };
          video.addEventListener('play', sync, options);
          video.addEventListener('pause', sync, options);
          video.addEventListener('volumechange', sync, options);
          card.querySelector('[data-play]').addEventListener('click', () => {
            item.userPaused = !video.paused;
            if (video.paused) {
              item.userStarted = true;
              video.play().catch(sync);
            } else {
              video.pause();
            }
            sync();
          }, options);
          card.querySelector('[data-sound]').addEventListener('click', () => {
            const unmute = video.muted;
            this.cards.forEach(other => { other.video.muted = true; });
            video.muted = !unmute;
          }, options);
          sync();
          return item;
        });
        if (!this.cards.length) return;
        this.updatePlayback = () => this.cards.forEach(item => {
          const allowed = item.userStarted || (this.dataset.autoplay === 'true' && !this.motion.matches);
          if (item.visible && !document.hidden && !item.userPaused && allowed) {
            item.video.play().catch(() => {});
          } else {
            item.video.pause();
          }
        });
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const item = this.cards.find(candidate => candidate.card === entry.target);
            if (item) item.visible = entry.isIntersecting;
          });
          this.updatePlayback();
        }, { threshold: 0.1 });
        this.cards.forEach(item => this.observer.observe(item.card));
        this.motion.addEventListener('change', () => {
          this.cards.forEach(item => { item.userStarted = false; });
          this.updatePlayback();
        }, options);
        document.addEventListener('visibilitychange', this.updatePlayback, options);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.cards?.forEach(item => item.video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-faq"] && !Shopify.designMode) return;
  try {
    
  if (!window.__supportFaqAccordionsBound) {
    const setSupportFaqOpen = (button, open) => {
      const root = button.closest('.support-faq');
      const panelId = button.getAttribute('aria-controls');
      const panel = root && panelId ? root.querySelector(`#${CSS.escape(panelId)}`) : null;
      if (!panel) return;

      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      panel.inert = !open;
      button.querySelector('.support-faq__icon')?.classList.toggle('is-open', open);
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-support-faq-button]');
      if (!button) return;
      setSupportFaqOpen(button, button.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('shopify:block:select', (event) => {
      const button = event.target.querySelector('[data-support-faq-button]');
      if (button) setSupportFaqOpen(button, true);
    });

    window.__supportFaqAccordionsBound = true;
  }

  } catch(e) { console.error(e); }
})();
})();
